import { render } from "./DeletedPermissionsList.vue?vue&type=template&id=b70e3e90&scoped=true"
import script from "./DeletedPermissionsList.vue?vue&type=script&lang=js"
export * from "./DeletedPermissionsList.vue?vue&type=script&lang=js"

import "./DeletedPermissionsList.vue?vue&type=style&index=0&id=b70e3e90&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b70e3e90"]])

export default __exports__